import { WizardService } from '../../services/wizard.service';
import { StepModel } from '../../model/steps.model';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-steps',
    templateUrl: './steps.component.html',
    styleUrls: ['./steps.component.scss'],
    standalone: false,
})
export class StepsComponent implements OnInit {
    steps!: Observable<StepModel[]>;
    currentStep!: Observable<StepModel>;

    constructor(private stepsService: WizardService) {}

    ngOnInit(): void {
        this.steps = this.stepsService.getSteps();
        this.currentStep = this.stepsService.getCurrentStep();
    }

    onStepClick(step: StepModel): void {
        this.stepsService.setCurrentStep(step);
    }

    stepLength(): number {
        return this.stepsService.stepsCount;
    }
}
